<template>
    <div>
        <h1>Welcome to {{ settings.applicationname }}</h1>
        <div class="shadow p-3 mb-5 bg-white rounded">
            {{ settings.applicationname }} is the online platform to record progress and manage your {{ settings.appraisal }}.
        </div>
    </div>
</template>

<script>
export default {
    props: {
    },
    computed: {
        settings () {
            return this.$store.getters.settings
        }
    }
}
</script>